import { TemplateConfig } from '../../features/template-designer/model/types';
import { API_CONFIG, API_ENDPOINTS, authFetch, getHeadersWithOrg } from './client';

/**
 * POST the current (unsaved) template config to the backend preview renderer.
 * Returns the full HTML string of the rendered page, byte-identical to what
 * page_builder.py produces at publish time.
 *
 * The body is the camelCase wire shape (the backend mirrors the designer's wire
 * JSON 1:1, exactly as the `saveTemplate` flow does — no snake_case conversion).
 * `resolvedCss` must already be baked into `config` before calling (the publisher
 * consumes it verbatim).
 */
export async function fetchTemplatePreview(config: TemplateConfig): Promise<string> {
  const response = await authFetch(
    `${API_CONFIG.BASE_URL}${API_ENDPOINTS.TEMPLATE_PREVIEW}`,
    {
      method: 'POST',
      headers: { ...getHeadersWithOrg(), 'Content-Type': 'application/json' },
      body: JSON.stringify(config),
    },
  );
  if (!response.ok) {
    throw new Error(`Template preview failed: ${response.status}`);
  }
  return response.text();
}
